'use strict';

var e = e || {};
e.scope = {};
e.ASSUME_ES5 = !1;
e.ASSUME_NO_NATIVE_MAP = !1;
e.ASSUME_NO_NATIVE_SET = !1;
e.defineProperty = e.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
  a != Array.prototype && a != Object.prototype && (a[b] = c.value);
};

e.getGlobal = function (a) {
  return "undefined" != typeof window && window === a ? a : "undefined" != typeof global && null != global ? global : a;
};

e.global = e.getGlobal(this);
e.SYMBOL_PREFIX = "jscomp_symbol_";

e.initSymbol = function () {
  e.initSymbol = function () {};

  e.global.Symbol || (e.global.Symbol = e.Symbol);
};

e.Symbol = function () {
  var a = 0;
  return function (b) {
    return e.SYMBOL_PREFIX + (b || "") + a++;
  };
}();

e.initSymbolIterator = function () {
  e.initSymbol();
  var a = e.global.Symbol.iterator;
  a || (a = e.global.Symbol.iterator = e.global.Symbol("iterator"));
  "function" != typeof Array.prototype[a] && e.defineProperty(Array.prototype, a, {
    configurable: !0,
    writable: !0,
    value: function value() {
      return e.arrayIterator(this);
    }
  });

  e.initSymbolIterator = function () {};
};

e.arrayIterator = function (a) {
  var b = 0;
  return e.iteratorPrototype(function () {
    return b < a.length ? {
      done: !1,
      value: a[b++]
    } : {
      done: !0
    };
  });
};

e.iteratorPrototype = function (a) {
  e.initSymbolIterator();
  a = {
    next: a
  };

  a[e.global.Symbol.iterator] = function () {
    return this;
  };

  return a;
};

e.iteratorFromArray = function (a, b) {
  e.initSymbolIterator();
  a instanceof String && (a += "");
  var c = 0,
      f = {
    next: function next() {
      if (c < a.length) {
        var d = c++;
        return {
          value: b(d, a[d]),
          done: !1
        };
      }

      f.next = function () {
        return {
          done: !0,
          value: void 0
        };
      };

      return f.next();
    }
  };

  f[Symbol.iterator] = function () {
    return f;
  };

  return f;
};

e.polyfill = function (a, b) {
  if (b) {
    var c = e.global;
    a = a.split(".");

    for (var f = 0; f < a.length - 1; f++) {
      var d = a[f];
      d in c || (c[d] = {});
      c = c[d];
    }

    a = a[a.length - 1];
    f = c[a];
    b = b(f);
    b != f && null != b && e.defineProperty(c, a, {
      configurable: !0,
      writable: !0,
      value: b
    });
  }
};

e.polyfill("Array.prototype.values", function (a) {
  return a ? a : function () {
    return e.iteratorFromArray(this, function (a, c) {
      return c;
    });
  };
}, "es8", "es3");
Object.defineProperty(exports, "__esModule", {
  value: !0
});

function h(a) {
  return a && "object" === typeof a && "default" in a ? a["default"] : a;
}

var l = h(require("babel-runtime/core-js/object/get-prototype-of")),
    n = h(require("babel-runtime/helpers/classCallCheck")),
    q = h(require("babel-runtime/helpers/createClass")),
    r = h(require("babel-runtime/helpers/possibleConstructorReturn")),
    t = h(require("babel-runtime/helpers/inherits")),
    u = require("react"),
    w = h(require("prop-types")),
    y = h(require("hash-sum")),
    A = require("@lingui/core"),
    B = h(require("babel-runtime/helpers/extends")),
    C = h(require("hoist-non-react-statics")),
    D = h(require("babel-runtime/core-js/get-iterator")),
    E = h(require("babel-runtime/helpers/slicedToArray")),
    G = h(require("babel-runtime/core-js/object/keys")),
    H = h(require("babel-runtime/helpers/toConsumableArray")),
    I = h(require("babel-runtime/helpers/objectWithoutProperties"));

function L(a) {
  var b = [];
  return {
    i18n: a,
    i18nHash: null,
    getSubscribers: function getSubscribers() {
      return b;
    },
    subscribe: function subscribe(c) {
      b.push(c);
    },
    unsubscribe: function unsubscribe(c) {
      b = b.filter(function (a) {
        return a !== c;
      });
    },
    update: function update() {
      var c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          f = c.catalogs,
          d = c.language;
      c = c.locales;
      if (f || d || c) f && a.load(f), d && a.activate(d, c), this.i18nHash = y([a.language, a.messages]), b.forEach(function (c) {
        return c();
      });
    }
  };
}

var M = function (a) {
  function b(c) {
    n(this, b);
    var a = r(this, (b.__proto__ || l(b)).call(this, c)),
        d = c.language,
        g = c.locales,
        k = c.catalogs;
    c = c.i18n || A.setupI18n({
      language: d,
      locales: g,
      catalogs: k
    });
    a.linguiPublisher = new L(c);
    a.linguiPublisher.i18n._missing = a.props.missing;
    return a;
  }

  t(b, a);
  q(b, [{
    key: "componentDidUpdate",
    value: function value(c) {
      var a = this.props,
          b = a.language,
          g = a.locales;
      a = a.catalogs;
      b === c.language && g === c.locales && a === c.catalogs || this.linguiPublisher.update({
        language: b,
        catalogs: a,
        locales: g
      });
      this.linguiPublisher.i18n._missing = this.props.missing;
    }
  }, {
    key: "getChildContext",
    value: function value() {
      return {
        linguiPublisher: this.linguiPublisher,
        linguiDefaultRender: this.props.defaultRender
      };
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]);
  return b;
}(u.Component);

M.defaultProps = {
  defaultRender: null
};
M.childContextTypes = {
  linguiPublisher: w.object.isRequired,
  linguiDefaultRender: w.any
};

var N = function (a) {
  function b() {
    var c, a, d, g;
    n(this, b);

    for (var k = arguments.length, m = Array(k), v = 0; v < k; v++) m[v] = arguments[v];

    return g = (a = (d = r(this, (c = b.__proto__ || l(b)).call.apply(c, [this].concat(m))), d), d.checkUpdate = function () {
      d.forceUpdate();
    }, a), r(d, g);
  }

  t(b, a);
  q(b, [{
    key: "componentDidMount",
    value: function value() {
      var c = this.getI18n().subscribe;
      this.props.update && c && c(this.checkUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      var c = this.getI18n().unsubscribe;
      this.props.update && c && c(this.checkUpdate);
    }
  }, {
    key: "getI18n",
    value: function value() {
      return this.context.linguiPublisher || {};
    }
  }, {
    key: "render",
    value: function value() {
      var c = this.props,
          a = c.children;
      c = c.withHash;
      var b = this.getI18n(),
          g = b.i18nHash;
      c = B({
        i18n: b.i18n
      }, c ? {
        i18nHash: g
      } : {});
      return "function" === typeof a ? a(c) : u.isValidElement(a) ? u.cloneElement(a, c) : u.createElement(a, c);
    }
  }]);
  return b;
}(u.Component);

N.defaultProps = {
  update: !0,
  withHash: !0
};
N.contextTypes = {
  linguiPublisher: w.object
};

function O() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
  return function (b) {
    var c = a.update,
        f = void 0 === c ? !0 : c;
    c = a.withHash;
    var d = void 0 === c ? !0 : c;
    c = a.withRef;
    var g = void 0 === c ? !1 : c;

    c = function (a) {
      function c() {
        var a, b, d, f;
        n(this, c);

        for (var m = arguments.length, k = Array(m), x = 0; x < m; x++) k[x] = arguments[x];

        return f = (b = (d = r(this, (a = c.__proto__ || l(c)).call.apply(a, [this].concat(k))), d), d.wrappedInstance = null, d.setWrappedInstance = function (a) {
          g && (d.wrappedInstance = a);
        }, d.getWrappedInstance = function () {
          if (!g) throw Error("To access the wrapped instance, you need to specify { withRef: true } in the options argument of the withI18n() call.");
          return d.wrappedInstance;
        }, b), r(d, f);
      }

      t(c, a);
      q(c, [{
        key: "render",
        value: function value() {
          var a = B({}, this.props, g ? {
            ref: this.setWrappedInstance
          } : {});
          return u.createElement(N, {
            update: f,
            withHash: d
          }, function (c) {
            return u.createElement(b, B({}, a, {
              i18n: c.i18n,
              i18nHash: c.i18nHash
            }));
          });
        }
      }]);
      return c;
    }(u.Component);

    c.contextTypes = {
      linguiPublisher: w.object
    };
    return C(c, b);
  };
}

var P = /<(\d+)>(.*)<\/\1>|<(\d+)\/>/,
    Q = /(?:\r\n|\r|\n)/g;

function R(a) {
  var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
      c = a.replace(Q, "").split(P);
  if (1 === c.length) return a;
  var f = [],
      d = c.shift();
  d && f.push(d);
  d = !0;
  var g = !1,
      k = void 0;

  try {
    for (var m = D(S(c)), v; !(d = (v = m.next()).done); d = !0) {
      var F = E(v.value, 3),
          J = F[0],
          K = F[1],
          z = F[2],
          p = b[J];
      f.push(u.cloneElement(p, {
        key: J
      }, K ? R(K, b) : p.props.children));
      z && f.push(z);
    }
  } catch (x) {
    g = !0, k = x;
  } finally {
    try {
      !d && m.return && m.return();
    } finally {
      if (g) throw k;
    }
  }

  return f;
}

function S(a) {
  if (!a.length) return [];
  var b = a.slice(0, 4);
  b = E(b, 4);
  var c = b[1],
      f = b[2],
      d = b[3];
  return [[parseInt(b[0] || f), c || "", d]].concat(S(a.slice(4, a.length)));
}

var T = function (a) {
  function b() {
    n(this, b);
    return r(this, (b.__proto__ || l(b)).apply(this, arguments));
  }

  t(b, a);
  q(b, [{
    key: "render",
    value: function value() {
      var a = this.props,
          b = a.className;
      a = a.value;
      var d = this.props.render || this.context.linguiDefaultRender;
      return null === d || void 0 === d ? a : "string" === typeof d ? u.createElement(d, {
        className: b
      }, a) : u.isValidElement(d) ? u.cloneElement(d, {}, a) : u.createElement(d, {
        translation: a
      });
    }
  }]);
  return b;
}(u.Component);

T.contextTypes = {
  linguiDefaultRender: w.any
};

var U = function (a) {
  function b() {
    n(this, b);
    return r(this, (b.__proto__ || l(b)).apply(this, arguments));
  }

  t(b, a);
  q(b, [{
    key: "componentDidMount",
    value: function value() {}
  }, {
    key: "getTranslation",
    value: function value() {
      var a = this.props,
          b = a.id;
      b = void 0 === b ? "" : b;
      var d = a.defaults,
          g = a.i18n;
      a = a.formats;
      var k = B({}, this.props.values),
          m = this.props.components ? [].concat(H(this.props.components)) : [];
      k && G(k).forEach(function (a) {
        var b = k[a];
        u.isValidElement(b) && (b = m.push(b) - 1, k[a] = "\x3c" + b + "/\x3e");
      });
      return (a = g && "function" === typeof g._ ? g._(b, k, {
        defaults: d,
        formats: a
      }) : b) ? R(a, m) : null;
    }
  }, {
    key: "render",
    value: function value() {
      return u.createElement(T, {
        render: this.props.render,
        className: this.props.className,
        value: this.getTranslation()
      });
    }
  }]);
  return b;
}(u.Component),
    V = O()(U),
    W = O()(function (a) {
  function b() {
    n(this, b);
    return r(this, (b.__proto__ || l(b)).apply(this, arguments));
  }

  t(b, a);
  q(b, [{
    key: "render",
    value: function value() {
      var a = this.props,
          b = a.className,
          d = a.render,
          g = a.i18n;
      a = I(a, ["className", "render", "i18n"]);
      return u.createElement(T, {
        className: b,
        render: d,
        value: g.select(a)
      });
    }
  }]);
  return b;
}(u.Component));

function X() {
  var a,
      b,
      c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : !1,
      f = c ? "SelectOrdinal" : "Plural",
      d = c ? "selectOrdinal" : "plural";
  return b = a = function (a) {
    function b() {
      var a, c, d, g;
      n(this, b);

      for (var k = arguments.length, z = Array(k), p = 0; p < k; p++) z[p] = arguments[p];

      return g = (c = (d = r(this, (a = b.__proto__ || l(b)).call.apply(a, [this].concat(z))), d), d.displayName = f, c), r(d, g);
    }

    t(b, a);
    q(b, [{
      key: "render",
      value: function value() {
        var a = this.props,
            b = a.className,
            c = a.render,
            f = a.i18n,
            g = a.value,
            k = a.offset,
            p = I(a, ["className", "render", "i18n", "value", "offset"]);
        a = G(p).reduce(function (a, b) {
          var c = b.replace("_", "");
          a[c] = p[b];
          return a;
        }, {
          value: Number(g),
          offset: Number(k)
        });
        return u.createElement(T, {
          className: b,
          render: c,
          value: f[d](a)
        });
      }
    }]);
    return b;
  }(u.Component), a.defaultProps = {
    offset: 0
  }, b;
}

var Y = O()(X(!1)),
    aa = O()(X(!0));

function Z(a) {
  return function (b) {
    var c = b.value,
        f = b.i18n,
        d = b.className,
        g = b.render;
    b = a(f.locales || f.language, b.format);
    return u.createElement(T, {
      className: d,
      render: g,
      value: b(c)
    });
  };
}

var ba = O()(Z(A.date)),
    ca = O()(Z(A.number));

exports.i18nMark = function (a) {
  return a;
};

exports.withI18n = O;
exports.I18nProvider = M;
exports.I18n = N;
exports.Trans = V;
exports.Plural = Y;
exports.Select = W;
exports.SelectOrdinal = aa;
exports.DateFormat = ba;
exports.NumberFormat = ca;